import {
  EntryFieldDropdownComponent,
  EntryFieldRadioComponent,
} from '@ifaa-components/ui-components';
import {
  Directive,
  ElementRef,
  Renderer2,
  Input,
  Host,
  Self,
  Optional,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { details_Genders } from '../views/member-join/steps/nmj-details/selectors';

@Directive({
  selector: '[list]',
})
export class AppListDirective {
  constructor(
    public store: Store<AppState>,
    public renderer: Renderer2,
    public hostElement: ElementRef,
    @Host() @Self() @Optional() public radio: EntryFieldRadioComponent,
    @Host() @Self() @Optional() public select: EntryFieldDropdownComponent
  ) {
    // if(this.button)
    // this.button.isLoading = commomState_IsLoading;
  }

  ngOnChanges() {
    var dd = '';
  }
  ngAfterViewInit(): void {}

  @Input() set list(value: string) {
    switch (value) {
      case 'gender':
        this.setList(this.store.pipe(select(details_Genders)));
        break;
    }
  }

  setList(list: any) {
    if (this.radio) {
      this.radio.customList = list;
    }
    if (this.select) {
      this.select.customList = list;
    }
  }
}
